import type { ReactNode } from 'react';
import './TimeOptionGrid.scss';

export interface TimeOptionItem {
    id: number;
    content: ReactNode;
    disabled?: boolean;
}

interface TimeOptionGridProps {
    items: TimeOptionItem[];
    selectedId: number | null;
    onSelect: (id: number) => void;
    emptyText: string;
}

export function TimeOptionGrid({ items, selectedId, onSelect, emptyText }: TimeOptionGridProps) {
    if (items.length === 0) {
        return <div className="time-option-grid__empty">{emptyText}</div>;
    }

    return (
        <div className="time-option-grid">
            {items.map((item) => {
                const isSelected = selectedId === item.id;

                return (
                    <button
                        key={item.id}
                        type="button"
                        className={`time-option-grid__item ${isSelected ? 'time-option-grid__item--selected' : ''} ${item.disabled ? 'time-option-grid__item--disabled' : ''}`}
                        disabled={item.disabled}
                        onClick={() => onSelect(item.id)}
                    >
                        {item.content}
                    </button>
                );
            })}
        </div>
    );
}
